<template>
  <div class="relative">
    <textarea
      v-if="type === 'textarea'"
      :value="modelValue"
      :class="['form-control z-10 rounded-lg border-2 p-6 focus:border-primary/25 ', innerClass]"
      :autofocus="autofocus"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :name="name"
      :rows="rows"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
    <input
      v-else
      :value="modelValue"
      :class="['form-control z-10 h-14 rounded-lg border-2 px-4 py-2 focus:border-primary/25', innerClass]"
      :autofocus="autofocus"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :name="name"
      :type="type"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    innerClass: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 50
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    rows: {
      type: Number,
      default: 8
    },
    autocomplete: {
      type: String,
      default: undefined
    }
  },
  emits: ['update:modelValue']
}
</script>
